import script from "./TheSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheSidebar.vue?vue&type=script&lang=ts&setup=true"

import "./TheSidebar.vue?vue&type=style&index=0&id=68181588&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68181588"]])

export default __exports__